// SidebarTableSelector.jsx
const SidebarDatasetSelector = ({ datasets, selectedDataset, onChange }) => {
  return (
    <div className="list-group">
      {datasets.map(dataset => (
        <label className="list-group-item" key={dataset}>
          <input
            type="radio"
            checked={selectedDataset===dataset}
            onChange={() => onChange(dataset)}
          />{" "}
          {dataset}
        </label>
      ))}
    </div>
  );
}
export default SidebarDatasetSelector